import { render, staticRenderFns } from "./ViewInvoicesView.vue?vue&type=template&id=b640127a&"
import script from "./ViewInvoicesView.vue?vue&type=script&lang=js&"
export * from "./ViewInvoicesView.vue?vue&type=script&lang=js&"
import style0 from "./ViewInvoicesView.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports